<div class="header-with-logo">
  <app-light-logo></app-light-logo>
<!--  <app-language class="language-selection" [blackArrow]="true">-->
<!--  </app-language>-->
<!--  <app-services-health [modeLarge]="true" [autoReload]="false"></app-services-health>-->
</div>
